import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  properties,
  propertiesMobile,
} from '../../assets/js/particles-properties';
import { Title } from '@angular/platform-browser';

declare var particlesJS: any;
declare var ScrollMagic: any;
declare var TimelineMax: any;
declare var Power4: any;

@Component({
  selector: 'app-work',
  templateUrl: './work.component.html',
  styleUrls: ['./work.component.css'],
})
export class WorkComponent implements OnInit, OnDestroy {
  constructor(private titleService: Title) {}

  title = 'Work - Rahil Hastu';

  ngOnInit(): void {
    this.titleService.setTitle(this.title);

    console.log('reloadss');
    let body = document.querySelector('body');
    let nav = document.querySelector('nav');
    let addParticle = document.querySelector('.addParticles');

    setTimeout(() => {
      addParticle.classList.add('fadeBar');
    }, 5000);

    if (!body.classList.contains('container-work')) {
      body.classList.add('container-work');
      nav.classList.add('work-nav');
    }

    var mq = window.matchMedia('(max-width: 1024px)');
    let props: any;
    if (mq.matches) {
      props = propertiesMobile;
    } else {
      props = properties;
    }

    particlesJS('particles-js', props, function () {
      console.log('callback');
    });

    let wh = window.innerHeight,
      intro = document.querySelector('#intro'),
      first = document.querySelector('#first'),
      second = document.querySelector('#second'),
      third = document.querySelector('#third'),
      fourth = document.querySelector('#fourth'),
      circle = document.querySelector('.circle'),
      introCircle = document.querySelector('#intro .circle'),
      firstCircle = document.querySelector('#first .circle'),
      secondCircle = document.querySelector('#second .circle'),
      thirdCircle = document.querySelector('#third .circle'),
      fourthCircle = document.querySelector('#fourth .circle'),
      projectSection = document.querySelectorAll('.proj-section'),
      ropeCircleIntro = document.querySelector('.interval-0-intro div'),
      ropeCircle1 = document.querySelector('.interval-1-proj div'),
      ropeCircle2 = document.querySelector('.interval-2-proj div'),
      ropeCircle3 = document.querySelector('.interval-3-proj div'),
      ropeCircle4 = document.querySelector('.interval-4-proj div'),
      introTitle = document.querySelector('.intro-title'),
      firstTitle = document.querySelector('.first-title'),
      secondTitle = document.querySelector('.second-title'),
      thirdTitle = document.querySelector('.third-title'),
      fourthTitle = document.querySelector('.fourth-title'),
      man = document.querySelector('.man');

    // init
    var ctrl = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: 'onLeave',
      },
    });

    // Create scene
    projectSection.forEach((projs) => {
      new ScrollMagic.Scene({
        triggerElement: projs,
        duration: '20%',
      })
        .setPin(projs)
        .addTo(ctrl);
    });

    //Intro fade out, Proj 1 fade in

    var introToproj1 = new TimelineMax();
    introToproj1
      .to(introCircle, 5, {
        xPercent: -20,
        position: 'fixed',
        autoAlpha: 0,
        ease: Power4.easeInOut,
      })
      .to(
        introTitle,
        2,
        {
          yPercent: -20,
          autoAlpha: 0,
          ease: Power4.easeInOut,
        },
        0
      )
      .to(man, 1, { left: '27.5%' }, 0)
      .to(ropeCircleIntro, 1, { className: '-=innerCircle' }, 0)
      .fromTo(
        firstCircle,
        5,
        { scale: '0', autoAlpha: 0 },
        {
          position: 'fixed',
          autoAlpha: 1,
          ease: Power4.easeInOut,
          scale: '1',
        },
        3
      )
      .fromTo(
        firstTitle,
        5,
        { left: '40%', yPercent: +20, autoAlpha: 0 },
        {
          yPercent: 0,
          position: 'fixed',
          autoAlpha: 1,
          ease: Power4.easeInOut,
        },
        3
      )
      .to(ropeCircle1, 1, { className: '+=innerCircle' }, 2);

    new ScrollMagic.Scene({
      triggerElement: intro[0],
      duration: '100%',
    })
      .setTween(introToproj1)
      .addTo(ctrl);

    //Proj 1 fade out, Proj 2 fade in
    var introToproj2 = new TimelineMax();
    introToproj2
      .to(firstCircle, 5, {
        autoAlpha: 0,
        yPercent: -20,
        ease: Power4.easeInOut,
      })
      .to(
        firstTitle,
        2,
        {
          yPercent: -20,
          autoAlpha: 0,
          ease: Power4.easeInOut,
        },
        0
      )
      .to(man, 1, { left: '47.5%' }, 0)
      .to(ropeCircle1, 1, { className: '-=innerCircle' }, 0)
      .fromTo(
        secondCircle,
        5,
        { autoAlpha: 0, scale: '0' },
        { position: 'fixed', autoAlpha: 1, ease: Power4.easeInOut, scale: '1' },
        3
      )
      .fromTo(
        secondTitle,
        5,
        { left: '60%', yPercent: +20, autoAlpha: 0 },
        {
          yPercent: 0,
          position: 'fixed',
          autoAlpha: 1,
          ease: Power4.easeInOut,
        },
        3
      )
      .to(ropeCircle2, 1, { className: '+=innerCircle' }, 2);

    new ScrollMagic.Scene({
      triggerElement: first,
      duration: '100%',
    })
      .setTween(introToproj2)
      .addTo(ctrl);

    //Proj 2 fade out, Proj 3 fade in

    var introToproj3 = new TimelineMax();
    introToproj3
      .to(secondCircle, 5, {
        // yPercent: -10,
        xPercent: 20,
        autoAlpha: 0,
        ease: Power4.easeInOut,
      })
      .to(
        secondTitle,
        2,
        {
          yPercent: -20,
          autoAlpha: 0,
          ease: Power4.easeInOut,
        },
        0
      )
      .to(man, 1, { left: '67.5%' }, 0)
      .to(ropeCircle2, 1, { className: '-=innerCircle' }, 0)
      .fromTo(
        thirdCircle,
        5,
        { autoAlpha: 0, scale: '0' },
        { position: 'fixed', autoAlpha: 1, ease: Power4.easeInOut, scale: '1' },
        3
      )
      .fromTo(
        thirdTitle,
        5,
        { left: '50%', yPercent: +20, autoAlpha: 0 },
        {
          yPercent: 0,
          position: 'fixed',
          autoAlpha: 1,
          ease: Power4.easeInOut,
        },
        3
      )
      .to(ropeCircle3, 1, { className: '+=innerCircle' }, 2);

    new ScrollMagic.Scene({
      triggerElement: second,
      duration: '100%',
    })
      .setTween(introToproj3)
      .addTo(ctrl);

    //Proj 3 fade out, Proj 4 fade in

    var introToproj4 = new TimelineMax();
    introToproj4
      .to(thirdCircle, 5, {
        autoAlpha: 0,
        // yPercent: -10,
        yPercent: 20,
        ease: Power4.easeInOut,
      })
      .to(
        thirdTitle,
        2,
        {
          yPercent: -20,
          autoAlpha: 0,
          ease: Power4.easeInOut,
        },
        0
      )
      .to(man, 1, { left: '87.5%' }, 0)
      .to(ropeCircle3, 1, { className: '-=innerCircle' }, 0)
      .fromTo(
        fourthCircle,
        5,
        { autoAlpha: 0, scale: '0' },
        { position: 'fixed', autoAlpha: 1, ease: Power4.easeInOut, scale: '1' },
        3
      )
      .fromTo(
        fourthTitle,
        5,
        { left: '70%', yPercent: +20, autoAlpha: 0 },
        {
          yPercent: 0,
          position: 'fixed',
          autoAlpha: 1,
          ease: Power4.easeInOut,
        },
        3
      )
      .to(ropeCircle4, 1, { className: '+=innerCircle' }, 2);

    new ScrollMagic.Scene({
      triggerElement: third,
      duration: '100%',
    })
      .setTween(introToproj4)
      .addTo(ctrl);

    // window.event
  }

  sectionChange(projNum) {
    document.getElementById(projNum).scrollIntoView(true);
  }

  ngOnDestroy() {
    let nav = document.querySelector('nav');
    let body = document.querySelector('body');
    body.classList.remove('container-work');
    nav.classList.remove('work-nav');
    window.scrollTo(0, 0);
  }
}
